export const faqs = [
  {
    question: 'Is this a physical product?',
    answer:
      'No. HALLOWEEN PE READY™ is a 100% digital product. You receive downloadable PDF files that you can view on a computer or tablet, and selected resources are designed to be printed.',
  },
  {
    question: 'What ages is it designed for?',
    answer:
      'The system is mainly designed for elementary and middle school PE. It includes adaptation guidance for K–2, Grades 3–5 and Middle School. The complete system is in English.',
  },
  {
    question: 'Do I need special PE equipment?',
    answer:
      'No. Many activities use common PE equipment such as cones, hoops, beanbags and soft balls. The system also includes no-equipment and low-equipment options.',
  },
  {
    question: 'Can I use it with large classes or a small gym?',
    answer:
      'Yes. The guide includes strategies for classes of approximately 30–40 students (smaller zones, duplicated stations, timed rotations) and a dedicated small-space lesson section.',
  },
  {
    question: 'Can I use it without printing anything?',
    answer:
      'Yes. The main visual guide can be used digitally from a tablet, laptop or computer. Printing is optional for the Print & Play resources.',
  },
  {
    question: 'How do I receive the product?',
    answer: 'You receive digital access after completing your purchase.',
  },
]
